"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslationsProps = exports.checkoutNamspacedTranslations = void 0;
var _checkoutBasket = require("@ori/checkout-basket");
var _checkoutDelivery = require("@ori/checkout-delivery");
var _checkoutGodmode = require("@ori/checkout-godmode");
var _checkoutMerchandising = require("@ori/checkout-merchandising");
var _checkoutOfferHints = require("@ori/checkout-offer-hints");
var _checkoutOffers = require("@ori/checkout-offers");
var _checkoutPayment = require("@ori/checkout-payment");
var _checkoutQuickOrderForm = require("@ori/checkout-quick-order-form");
var _checkoutSummary = require("@ori/checkout-summary");
var _productBox = require("@ori/product-box");
var _productList = require("@ori/product-list");
var _defaultTranslations = require("../constants/defaultTranslations");
var _logger = require("../logger");
const checkoutNamspacedTranslations = exports.checkoutNamspacedTranslations = {
  [_defaultTranslations.translationsNamespace]: _defaultTranslations.defaultTranslations,
  [_checkoutBasket.translationsNamespace]: _checkoutBasket.defaultTranslations,
  [_checkoutDelivery.translationsNamespace]: _checkoutDelivery.defaultTranslations,
  [_checkoutOfferHints.translationsNamespace]: _checkoutOfferHints.defaultTranslations,
  [_checkoutOffers.translationsNamespace]: _checkoutOffers.defaultTranslations,
  [_checkoutMerchandising.translationsNamespace]: _checkoutMerchandising.defaultTranslations,
  [_checkoutQuickOrderForm.translationsNamespace]: _checkoutQuickOrderForm.defaultTranslations,
  [_checkoutSummary.translationsNamespace]: _checkoutSummary.defaultTranslations,
  [_checkoutPayment.translationsNamespace]: _checkoutPayment.defaultTranslations,
  [_checkoutGodmode.translationsNamespace]: _checkoutGodmode.defaultTranslations,
  [_productList.productListTranslationsNamespace]: _productList.productListDefaultTranslations,
  [_productBox.productBoxTranslationsNamespace]: _productBox.productBoxDefaultTranslations
};
const getTranslationsProps = ({
  currentLanguage,
  staticApiUrl,
  tenant
}) => {
  const result = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: error => {
        _logger.mainLogger.error(error, {
          action: 'Loading translations.'
        });
      },
      tenant
    },
    currentLanguage,
    defaultTranslationsWithNamespaces: checkoutNamspacedTranslations
  };
  return result;
};
exports.getTranslationsProps = getTranslationsProps;